module.exports = __webpack_public_path__ + "img/t2-9.280a1203.svg";